import { render, staticRenderFns } from "./IskazPeljeskiMost.vue?vue&type=template&id=b1a56186&scoped=true&"
import script from "./IskazPeljeskiMost.vue?vue&type=script&lang=js&"
export * from "./IskazPeljeskiMost.vue?vue&type=script&lang=js&"
import style1 from "./IskazPeljeskiMost.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a56186",
  null
  
)

export default component.exports